import React, { useMemo } from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { LANDMARK_META } from '../utils/mapLandmarks';
import { useMapLandmarks } from '../hooks/useMapLandmarks';

const landmarkIcon = (type) => {
  const meta = LANDMARK_META[type] || LANDMARK_META.tourist;
  return L.divIcon({
    className: 'srm-landmark-pin-root',
    html: `<div class="srm-landmark-pin" style="background:${meta.color}" title="${meta.label}">${meta.emoji}</div>`,
    iconSize: [26, 26],
    iconAnchor: [13, 13],
  });
};

const MapLandmarkMarkers = ({
  lat,
  lng,
  city,
  activeCategories,
  enabled = true,
  radius = 8000,
  landmarks: landmarksProp,
}) => {
  const fetched = useMapLandmarks({ lat, lng, city, enabled: enabled && !landmarksProp, radius });
  const landmarks = landmarksProp ?? fetched.landmarks;

  const visible = useMemo(() => {
    if (!activeCategories || activeCategories.size === 0) return landmarks;
    return landmarks.filter((lm) => activeCategories.has(lm.type));
  }, [landmarks, activeCategories]);

  return (
    <>
      {visible.map((lm) => (
        <Marker
          key={lm.id}
          position={[lm.lat, lm.lng]}
          icon={landmarkIcon(lm.type)}
          zIndexOffset={-100}
        >
          <Popup>
            <strong>{lm.name}</strong>
            <br />
            <span style={{ fontSize: '0.85em', color: '#64748b' }}>
              {(LANDMARK_META[lm.type] || LANDMARK_META.tourist).label}
            </span>
          </Popup>
        </Marker>
      ))}
    </>
  );
};

export default MapLandmarkMarkers;
